import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrontTooltipComponent } from './frontend-tooltip.component';
import { IonicModule } from '@ionic/angular';

@NgModule({
  declarations: [FrontTooltipComponent],
  exports: [FrontTooltipComponent],
  imports: [
    CommonModule,
    IonicModule,
  ],
})
export class FrontendTooltipModule { }
